var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row text-center justify-center"},[_c('p',{class:'text-dark w-600 no-padding no-margin ' +
      (_vm.$q.screen.lt.sm ? 'font-28' : 'font-38')},[_vm._v(" "+_vm._s(_vm.dark)),_c('span',{staticClass:"text-primary"},[_vm._v(_vm._s(_vm.light))]),_vm._v(_vm._s(_vm.append)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }